"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _UnassignedPresenterListItem = require("./UnassignedPresenterListItem.styled");
var UnassignedPresenterListItem = function UnassignedPresenterListItem(_ref) {
  var type = _ref.type;
  var iconTypeMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _.CAMERA_PRESENTER, _freeSolidSvgIcons.faUser), _.SCREEN_PRESENTER, _freeSolidSvgIcons.faTv);
  return /*#__PURE__*/_react["default"].createElement(_UnassignedPresenterListItem.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_UnassignedPresenterListItem.StyledIcon, {
    icon: iconTypeMap[type]
  }));
};
UnassignedPresenterListItem.propTypes = {
  type: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = UnassignedPresenterListItem;